import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../../styles/constants';

export const useRedirectButtonRoundStyles = makeStyles(theme => ({
	root: {
		width: props => (props.width ? props.width : '4em'),
		height: '2.3em',
		fontWeight: props => (props.bold ? theme.typography.fontWeightBold : theme.typography.fontWeightRegular),
		textTransform: props => (props.noTextTransform ? 'none' : 'uppercase'),
		whiteSpace: 'nowrap',
		border: `1px solid ${COLORS.PRIMARY}`,
		borderRadius: '25px',
		fontSize: '13px',
		padding: '0'
	}
}));
